import {
    FETCH_TEAM_REQUEST,
    FETCH_TEAM_SUCCESS,
    FETCH_SINGLE_TEAM_REQUEST,
    FETCH_SINGLE_TEAM_SUCCESS,
    FETCH_TEAM_SETTINGS_REQUEST,
    FETCH_TEAM_SETTINGS_SUCCESS,
    FETCH_TEAM_SETTINGS_FAILURE,
    FETCH_TASK_PROFILE_REQUEST,
    FETCH_TASK_PROFILE_SUCCESS,
    FETCH_TASK_PROFILE_FAILURE
} from 'common/constants/actionTypes';
import { team, teamSettings, taskProfile } from 'common/middleware/api';
import { injectError } from './error';
import { ApiError } from 'common/modules/api';

const handleApiError = (error, dispatch) => {
    if (error instanceof ApiError) {
        dispatch(injectError(error));
        return error;
    }
    throw error;
};

export const injectTeamSetting = setting => {
    return {
        type: FETCH_TEAM_SETTINGS_SUCCESS,
        response: setting
    };
};

export const injectTaskProfile = taskProfile => {
    return {
        type: FETCH_TASK_PROFILE_SUCCESS,
        response: taskProfile
    };
};

export const injectTeams = teams => {
    return {
        type: FETCH_TEAM_SUCCESS,
        response: teams
    };
};

export const injectTeam = team => {
    return {
        type: FETCH_SINGLE_TEAM_SUCCESS,
        response: team
    };
};

export const pollTeamsByClient = (...params) => {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                fetchTeamsByClient(...params, {
                    onSuccess: resolve,
                    onFailure: reject
                })
            );
        });
    };
};

export const fetchTeamsByClient = (
    { clientId },
    { onSuccess, onFailure } = {}
) => {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch({ type: FETCH_TEAM_REQUEST });
            return team
                .fetch({ clientId })
                .then(teams => {
                    resolve(teams);
                    onSuccess?.(teams);
                    dispatch(injectTeams(teams));
                    return;
                })
                .catch(error => {
                    reject(error);
                    onFailure?.(error);
                    handleApiError(error, dispatch);
                });
        });
    };
};

export const fetchTeam = (clientId, teamId) => {
    return dispatch => {
        dispatch({ type: FETCH_SINGLE_TEAM_REQUEST });
        team.fetch({ clientId, teamId })
            .then(team => dispatch(injectTeam(team)))
            .catch(error => handleApiError(error, dispatch));
    };
};

export const fetchTeamSettingsById = (teamId, clientId) => {
    return dispatch => {
        dispatch({ type: FETCH_TEAM_SETTINGS_REQUEST });
        teamSettings
            .fetch({ teamId, clientId })
            .then(settings => dispatch(injectTeamSetting(settings)))
            .catch(error => {
                dispatch({
                    type: FETCH_TEAM_SETTINGS_FAILURE,
                    response: error
                });
                handleApiError(error, dispatch);
            });
    };
};

export const fetchTaskProfile = (teamId, clientId, taskProfileId) => {
    return dispatch => {
        dispatch({ type: FETCH_TASK_PROFILE_REQUEST });

        taskProfile
            .fetch({ teamId, clientId, taskProfileId })
            .then(taskProfile => dispatch(injectTaskProfile(taskProfile)))
            .catch(error => {
                dispatch({ type: FETCH_TASK_PROFILE_FAILURE, response: error });
                handleApiError(error, dispatch);
            });
    };
};
